import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import GeneralReportLayer from "../components/GeneralReportLayer";

const GeneralReportPage = () => {
  return (
    <MasterLayout>
      <GeneralReportLayer />
    </MasterLayout>
  );
};

export default GeneralReportPage;
